import React, { useState } from 'react';
import { 
  Home, 
  Video, 
  Folder, 
  ChevronRight,
  ChevronDown,
  ExternalLink,
  FileText,
  BookOpen,
  LayoutGrid,
  StickyNote,
  CalendarDays
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

function MobileMenu() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { id: 'home', label: 'Panel', icon: Home, path: '/dashboard' },
    { id: 'meetings', label: 'Toplantılar', icon: Video, path: '/plans' },
    { id: 'calendar', label: 'Takvim', icon: CalendarDays, path: '/calendar' },
    { id: 'recordings', label: 'Kayıtlar', icon: Folder, path: '/recordings' },
    { id: 'agenda-pool', label: 'Gündem Havuzu', icon: BookOpen, path: '/agenda-pool' },
    { id: 'summaries', label: 'Toplantı Özetlerim', icon: FileText, path: '/summaries' },
  ];

  const productItems = [
    { label: 'Beyaz Tahtalar', icon: LayoutGrid, path: '/products/whiteboards' },
    { label: 'Notlar', icon: StickyNote, path: '/products/notes' },
    { label: 'Klipler', icon: ExternalLink, path: '/products/clips' },
    { label: 'Dokümanlar', icon: ExternalLink, path: '/products/documents' },
    { label: 'Görevler', icon: ExternalLink, path: '/products/tasks' },
  ];

  const currentPage = menuItems.find(item => 
    location.pathname === item.path || 
    (item.path === '/plans' && location.pathname.startsWith('/plans')) ||
    (item.path === '/calendar' && location.pathname.startsWith('/calendar'))
  );

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-4 py-3 bg-white/5 border-b border-white/10 text-white"
      >
        <span className="font-medium">{currentPage?.label || 'Panel'}</span>
        <ChevronDown className={`w-5 h-5 text-purple-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/50 z-40"
            onClick={() => setIsOpen(false)}
          />
          
          <div className="absolute top-full left-0 right-0 bg-slate-800 border-b border-white/10 shadow-xl z-50 max-h-[70vh] overflow-y-auto">
            <div className="py-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path || 
                  (item.path === '/plans' && location.pathname.startsWith('/plans')) ||
                  (item.path === '/calendar' && location.pathname.startsWith('/calendar'));
                return (
                  <Link
                    key={item.id}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`flex items-center space-x-3 px-4 py-3 transition ${
                      isActive
                        ? 'bg-purple-600/20 text-purple-400 border-l-4 border-purple-500'
                        : 'text-gray-300 hover:bg-white/5 border-l-4 border-transparent'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>

            <div className="border-t border-white/10" />

            <div className="py-2">
              <h3 className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">Ürünlerim</h3>
              {productItems.map((item, index) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-white/5 border-l-4 border-transparent"
                  >
                    <Icon className="w-4 h-4" />
                    <span className="text-sm">{item.label}</span>
                  </Link>
                );
              })}
            </div>

            <div className="border-t border-white/10" />

            <div className="py-2">
              <Link 
                to="/profile" 
                onClick={() => setIsOpen(false)}
                className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-white/5 border-l-4 border-transparent"
              >
                <ChevronRight className="w-4 h-4" />
                <span className="text-sm">Hesabım</span>
              </Link>
              <button className="w-full flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-white/5 text-left border-l-4 border-transparent">
                <ChevronRight className="w-4 h-4" />
                <span className="text-sm">Yönetici</span>
              </button>
              <button className="w-full flex items-center space-x-3 px-4 py-3 text-gray-300 hover:bg-white/5 text-left border-l-4 border-transparent">
                <ChevronRight className="w-4 h-4" />
                <span className="text-sm">Destek</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default MobileMenu;